export const baseUrl = process.env.REACT_APP_BASE_URL;
export const blogBaseUrl = process.env.REACT_APP_BLOG_URL;
export const HyperPayBaseUrl = process.env.REACT_APP_HYPERPAY_URL;
export const url = process.env.REACT_APP_WEBSITE_URL;
export const elastic_Url = process.env.REACT_APP_ELASTIC_URL;
export const business_id = process.env.REACT_APP_BUSINESS_PLAN_ID;
export const paypal_client_id = process.env.REACT_APP_PAYPAL_CLIENT_ID;
